exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".channelentry-component{width:100%;text-align:center;font-family:OratorStd!important;padding:50px 0}.channelentry-component input[type=text]{width:100%;position:relative;font-size:16pt;border:0;line-height:30px;background-color:transparent;text-align:center;color:red;font-family:OratorStd!important}.channelentry-component input[type=text]:focus{outline:none}.channelentry-component .channelentry-input{margin:80px auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/ChannelEntry.css
// module id = 719
// module chunks = 0